import Vue from "vue";
import mask, { maskCpf, maskPhone } from "./mask";
import formatDate from "./formatDate";

Vue.filter("mask", mask);
Vue.filter("maskCpf", maskCpf);
Vue.filter("maskPhone", maskPhone);
Vue.filter("formatDate", formatDate);
